"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileContextProvider = exports.TileContext = exports.defaultTileContext = void 0;

var _react = require("react");

var defaultTileContext = {
  compact: false
};
exports.defaultTileContext = defaultTileContext;
var TileContext = (0, _react.createContext)(defaultTileContext);
exports.TileContext = TileContext;
var Provider = TileContext.Provider;
exports.TileContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/context/TileContext.js
// module id = 405
// module chunks = 5 6